const SelectionFrame = ({ trimStart, trimEnd, handleMouseDown }) => {
    return (
        <>
            <div
                className="tw:absolute tw:top-0 tw:w-2 tw:h-full tw:bg-blue-300 tw:cursor-ew-resize tw:flex tw:items-center tw:justify-center"
                style={{
                    left: `${trimStart}%`,
                    borderRadius: '2px 0 0 2px',
                    transform: 'translateX(-4px)',
                }}
                onMouseDown={(e) => handleMouseDown(e, 'start')}
            >
                <div className="tw:h-3 tw:w-0.5 tw:bg-white tw:rounded-xs"></div>
            </div>
            <div
                className="tw:absolute tw:top-0 tw:h-0.5 tw:bg-blue-300 tw:w-8"
                style={{
                    left: `${trimStart}%`,
                    width: `${trimEnd - trimStart}%`,
                }}
            ></div>
            <div
                className="tw:absolute tw:top-0 tw:w-2 tw:h-full tw:bg-blue-300 tw:cursor-ew-resize tw:flex tw:items-center tw:justify-center"
                style={{
                    left: `${trimEnd}%`,
                    borderRadius: '0 2px 2px 0',
                    transform: 'translateX(-4px)',
                }}
                onMouseDown={(e) => handleMouseDown(e, 'end')}
            >
                <div className="tw:h-3 tw:w-0.5 tw:bg-white tw:rounded-xs"></div>
            </div>
            <div
                className="tw:absolute tw:bottom-0 tw:h-0.5 tw:bg-blue-300 tw:w-8"
                style={{
                    left: `${trimStart}%`,
                    width: `${trimEnd - trimStart}%`,
                }}
            ></div>
        </>
    )
}

export default SelectionFrame
